var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA0061"
    },
    d: "M200,100.001c0,55.228-44.771,100.001-100.001,100.001C44.771,200.002,0,155.229,0,100.001 S44.771,0,99.999,0C155.229,0,200,44.773,200,100.001"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.766,
    y: 138.924,
    style: {
      fill: "#D9D3CB"
    },
    width: 2.909,
    height: 2.911
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.248,
    y: 48.25,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -41.4223 100.0002)",
    style: {
      fill: "#D9D3CB"
    },
    width: 103.503,
    height: 103.503
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M84.013,49.925c2.542,3.875,4.032,8.503,4.032,13.484c0,13.606-11.03,24.639-24.639,24.639 c-4.981,0-9.609-1.49-13.486-4.032L38.465,95.471l62.619,62.621l57.527-57.527L95.992,37.946L84.013,49.925z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "61.546,71.949 61.546,141.185 65.266,141.185 65.266,71.949  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "141.693,139.063 71.938,69.308 69.308,71.94 139.063,141.693  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "66.369,75.422 106.334,171.907 109.771,170.483 69.806,73.999  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "79.579,58.722 121.776,41.243 120.352,37.806 78.155,55.285  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "42.216,119.423 59.944,76.623 56.507,75.2 38.779,118  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "174.772,107.523 74.618,66.039 73.195,69.476 173.349,110.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    points: "63.406,65.268 139.572,65.268 139.572,61.548 63.406,61.548  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M81.051,63.408c0,9.744-7.9,17.646-17.644,17.646c-9.746,0-17.649-7.902-17.649-17.646 c0-9.746,7.902-17.646,17.649-17.646C73.151,45.762,81.051,53.662,81.051,63.408"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.2d8621d9499113f3b55abf3d1dc87b6e.svg";
export { ForwardRef as ReactComponent };